type Props =  {
  children: React.ReactNode;
  onClose: () => void;
  onBack: () => void;
  hideBack?: boolean;
}

export function PanelCompra({ hideBack, children, onClose, onBack }: Props) {
  return (
    <div className="fixed bottom-0 left-0 w-full h-[75vh] z-[50] rounded-t-2xl overflow-y-auto backdrop-blur-md bg-primary-900/70 shadow-xl animate-slide-up">
      <div className="p-4 text-white">
        {/* Botón cerrar */}
        <div className={`flex ${!hideBack ? 'justify-between' : 'justify-end'}`}>
          {
            !hideBack &&
            <button
              onClick={onBack}
              className="text-white font-semibold mb-4"
            >
              ← Volver
            </button>
          }
          <button
            onClick={onClose}
            className="text-white font-semibold mb-4"
          >
            Cerrar
          </button>
        </div>

        {children}
      </div>
    </div>

  );
}
